import { useEffect, useState } from 'react';

const SEEN_KEY = 'pa.entrance_seen';

function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

function seenThisSession(): boolean {
  try {
    return sessionStorage.getItem(SEEN_KEY) === '1';
  } catch {
    return true;
  }
}

/**
 * The auth panel's hero: the question and the answer fade in once per session (320 ms), and
 * appear at once under prefers-reduced-motion. The large "TWO" heading is gone (M5.2): the mark
 * above and the closing line below carry the brand.
 */
export function PanelEntrance({ question, answer }: { question: string; answer: string }) {
  const animate = !prefersReducedMotion() && !seenThisSession();
  const [revealed, setRevealed] = useState(!animate);

  useEffect(() => {
    if (!animate) return;
    const timer = setTimeout(() => {
      setRevealed(true);
      try {
        sessionStorage.setItem(SEEN_KEY, '1');
      } catch {
        // ignore
      }
    }, 120);
    return () => clearTimeout(timer);
  }, [animate]);

  return (
    <div
      className={[
        'transition-[opacity,transform] duration-[var(--pa-dur-slow)] ease-[var(--pa-ease)]',
        revealed ? 'opacity-100' : 'translate-y-1 opacity-0',
      ].join(' ')}
    >
      <p className="text-3xl font-semibold leading-tight tracking-tight text-balance">{question}</p>
      <p className="mt-4 text-lg/relaxed text-ink-2">{answer}</p>
    </div>
  );
}
